function getValueTransition(transition, key) {
  var _ref, _transition$key;
  return (_ref = (_transition$key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition$key !== void 0 ? _transition$key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
}
export { getValueTransition };